import { render, staticRenderFns } from "./BrothersAndSisters.vue?vue&type=template&id=604760aa&scoped=true&"
import script from "./BrothersAndSisters.vue?vue&type=script&lang=js&"
export * from "./BrothersAndSisters.vue?vue&type=script&lang=js&"
import style0 from "./BrothersAndSisters.vue?vue&type=style&index=0&id=604760aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604760aa",
  null
  
)

export default component.exports